import React, { useState } from 'react';
import './LeaderBoardTopInt.css';

export default function LeaderBoardTopInt({ data, info }) {
	return (
		<div className="leaderBoardBox">
			<div className="leaderboardPoints">
				<div className="leaderboardColumn columnSecond">
					<div className="leaderboardColumnImg">
						<img src={data?.[1]?.orgLogo ? data?.[1]?.orgLogo : "https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-default-img.jpeg"} alt="person" width={50} height={50}/>
						<span className="pointNumber">2</span>
					</div>
					<h4>{data?.[1]?.orgName}</h4>
					<h2>{data?.[1]?.points}</h2>
					<p>POINTS</p>
				</div>
				<div className="leaderboardColumn columnFirst">
					<div className="leaderboardColumnImg">
						<img className="imgWinner" src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-winner.png" alt="cap" height={27} width={57}/>
						<img src={data?.[0]?.orgLogo ? data?.[0]?.orgLogo : "https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-default-img.jpeg"} alt="person" width={75} height={75}/>
						<span className="pointNumber">1</span>
					</div>
					<h4>{data?.[0]?.orgName}</h4>
					<h2>{data?.[0]?.points}</h2>
					<p>POINTS</p>
				</div>
				<div className="leaderboardColumn columnThird">
					<div className="leaderboardColumnImg">
						<img src={data?.[2]?.orgLogo ? data?.[2]?.orgLogo : "https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-default-img.jpeg"} alt="person" width={50} height={50}/>
						<span className="pointNumber">3</span>
					</div>
					<h4>{data?.[2]?.orgName}</h4>
					<h2>{data?.[2]?.points}</h2>
					<p>POINTS</p>
				</div>
			</div>
		</div>
	);
}
